console.log('klavio-api.js loaded');
// const apiKey = 'pk_0f5b49141eae00a289799dae2abbd3d769'; // Replace with your Klaviyo API key
// const listId = 'TwdzWZ'; // Replace with your Klaviyo List ID

document.getElementById('klaviyoForm').addEventListener('submit', async function(e) {
    e.preventDefault();

    const email = document.getElementById('email').value;
    const product = document.getElementById('product').value;
    const listId = 'TwdzWZ'; // Replace with your actual Klaviyo List ID

    // Create the payload as Klaviyo expects
    const data = new URLSearchParams({
      'g': listId,
      'email': email,
      'product_name': 'Sample Property' // Custom property
    });

    try {
      // Send the data to Klaviyo
      const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded' // Klaviyo expects form URL-encoded data
        },
        body: data
      });

      const result = await response.json();

      if (result.success) {
        // Show the thank you message
        document.getElementById('thankYouMessage').style.display = 'block';
        document.getElementById('errorMessage').style.display = 'none';
        document.getElementById('klaviyoForm').reset();
      } else {
        throw new Error(result.error);
      }
    } catch (error) {
      console.error('Error:', error);
      document.getElementById('errorMessage').style.display = 'block';
      document.getElementById('thankYouMessage').style.display = 'none';
    }
  });

